<template>
  <v-dialog v-model="dialog" width="90%">
    <v-card elevation="24">

      <div class="pp-sidenav">
        <v-card-title class="white--text">
          Edit an Image
        </v-card-title>

        <v-card-subtitle class="white--text">
          Amend details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <v-tabs dark
              width="250"
              color="primary"
              vertical>
        <v-tab class="pp-sidenav-2">
          <v-icon left>
            mdi-pencil
          </v-icon>
          Edit an Image
        </v-tab>

        <v-tab-item>
          <v-card flat v-if="currentImageItem">
            <v-container>
              <template>
                <v-card
                    color="grey lighten-4"
                    width="100%" flat
                >
                  <v-card-title class="text-h6 grey lighten-3">
                    Edit <span class="primary--text ml-2"> {{ currentImageItem.originalName }} </span>
                    <v-icon class="ml-1">mdi-chevron-right</v-icon>
                  </v-card-title>

                  <v-card-text>
                    <div class="py-10 px-2">

                      <v-row class="mb-5" justify="center">
                        <v-img
                            :src="currentImageItem.url"
                            max-height="300"
                            contain
                            label="Image"></v-img>
                      </v-row>

                      <v-row>
                        <v-text-field
                            v-model="editableImageItem.originalName"
                            label="Filename"
                            readonly
                            flat
                            solo
                            prepend-icon="mdi-file-edit-outline"
                            background-color="grey lighten-3"
                        ></v-text-field>
                      </v-row>

                      <v-row class="mb-8">
                        <v-textarea
                            v-model="editableImageItem.alt"
                            label="Specify alternate attribute (alt) of the image"
                            placeholder="Specify alternate attribute (alt) of the image"
                            prepend-icon="mdi-pound"
                            hint="Include text that is part of the image as an alternative text for the visual accessibility, and improve the Search Engine Optimisation (SEO). E.g: 'A teacher in a classroom' "
                            persistent-hint
                            flat
                            solo
                            aria-required="true"
                            color="primary"
                            clearable
                        ></v-textarea>
                      </v-row>


                      <v-row v-if="imageApiError && imageApiError.fields && imageAddError.fields.alt">
                        <p class="error--text">
                          Image alt should not be empty and contain letters and/or numbers.
                        </p>
                      </v-row>

                      <TagsInput
                          :validationError="imageApiError"
                          :item="editableImageItem"
                          v-model="editableImageItem.tags"
                      />

                      <v-row v-if="imageApiError">
                        <p class="error--text">
                          Errors in submission, please review the form
                        </p>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </v-container>
          </v-card>
          <div v-else>
            <UnavailableContent />
          </div>
        </v-tab-item>
      </v-tabs>

      <!-- ------------------------------------------ buttons ------------------------------------------ -->
      <div class="pp-sidenav">
        <div class="btm">
          <Loading v-if="imageItemLoading"/>
          <ConfirmCancelButtons
              :item="currentImageItem"
              :confirm-disabled="imageItemLoading"
              :confirm-action="editItemConfirm"
              :cancel-action="closeDialog"
              confirm-text="Save Changes"/>
        </div>
      </div>
      <!-- ------------------------------------------end of buttons ------------------------------------------ -->

    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "@/components/common/Loading";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import UnavailableContent from "@/components/common/UnavailableContent";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "ImageEdit",
  components: {TagsInput, UnavailableContent, Loading, ConfirmCancelButtons},
  computed: {
    ...mapGetters([
      'imageApiError', 'openDialog', 'currentImageItem', 'editableImageItem', 'imageItemLoading',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'imageEdit';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
    imageTags: {
      get() {
        return [{name: "Learning Plus Trusted Companies", handle: "learning_plus_companies"}, ...this.tags];
      },
    },
  },
  methods: {
    ...mapActions(['editImage', 'clearImageItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearImageItems();
    },
    async editItemConfirm() {
      const edited = await this.editImage(this.editableImageItem);

      if (edited) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
